import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import ReactList from 'react-list'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import get from 'lodash/get'
import set from 'lodash/set'
import orderBy from 'lodash/orderBy'
import moment from '../../lib/moment.js'
import shortid from 'shortid'
import arrow_down from '../../static/images/arrow-down.svg'
import arrow_up from '../../static/images/arrow-up.svg'
import { subcontract_rate_table } from './constants'
import { FONTS, COLORS } from '../../constants'

export default class SubcontractCostTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (JSON.stringify(get(nextProps, 'subContractCosts')) !== JSON.stringify(prevState.subContractCosts)) {
      let list
      switch (prevState.sort_column) {
        case 0: {
          list = orderBy(get(nextProps, 'subContractCosts'), 'emp_code', 'desc')
          break
        }
        case 1: {
          list = orderBy(get(nextProps, 'subContractCosts'), 'name', 'desc')
          break
        }
        case 2: {
          list = orderBy(get(nextProps, 'subContractCosts'), 'start_date', 'desc')
          break
        }
        case 3: {
          list = orderBy(get(nextProps, 'subContractCosts'), 'end_date', 'desc')
          break
        }
        case 4: {
          list = orderBy(get(nextProps, 'subContractCosts'), 'cost_number', 'desc')
          break
        }
        case 5: {
          list = orderBy(get(nextProps, 'subContractCosts'), 'price_number', 'desc')
          break
        }
        default: break
      }
      set(tempState, 'subContractCosts', get(nextProps, 'subContractCosts'))
      set(tempState, 'items', [...list])
    }
    return tempState
  }

  state={
    sort_order: false,
    sort_column: 0,
    subContractCosts: [],
    items: [],
  }

  handleClickSort = (column) => {
    let { sort_order } = { ...this.state }
    const { subContractCosts } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    switch (column) {
      case 0: {
        const newItems = orderBy(subContractCosts, 'emp_code', sort_order)
        return this.setState({ items: newItems })
      }
      case 1: {
        const newItems = orderBy(subContractCosts, 'name', sort_order)
        return this.setState({ items: newItems })
      }
      case 2: {
        const newItems = orderBy(subContractCosts, 'start_date', sort_order)
        return this.setState({ items: newItems })
      }
      case 3: {
        const newItems = orderBy(subContractCosts, 'end_date', sort_order)
        return this.setState({ items: newItems })
      }
      case 4: {
        const newItems = orderBy(subContractCosts, 'cost_number', sort_order)
        return this.setState({ items: newItems })
      }
      case 5: {
        const newItems = orderBy(subContractCosts, 'price_number', sort_order)
        return this.setState({ items: newItems })
      }
      default: return subContractCosts
    }
  }

  renderItem = (index, key) => {
    const data = this.state.items[index]
    const rowID = get(this.props, 'rowID')
    return (
      <tr
        key={ shortid() }
        style={ {
          cursor: 'pointer',
          hover: '#E5E5E5',
          backgroundColor: key === rowID ? '#E5E5E5' : '',
        } }
        onClick={ () => this.props.clickRow(key, data) }
      >
        <td>{ data.emp_code }</td>
        <td>{ data.name }</td>
        <td>{ moment(data.start_date).format('DD/MM/YYYY') }</td>
        <td>{ moment(data.end_date).format('DD/MM/YYYY') }</td>
        <td style={ { textAlign: 'right' } }>{
          <NumberFormat
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            displayType='text'
            value={ data.cost }
          />
        }</td>
        <td style={ { textAlign: 'right' } }>{
          <NumberFormat
            thousandSeparator={ true }
            decimalScale={ 2 }
            fixedDecimalScale={ true }
            displayType='text'
            value={ data.price }
          />
        }</td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, items } = this.state

    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <CustomTable bordered hover>
          <Header>
            <tr>
              { subcontract_rate_table.map((h) =>
                (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                  { h.label }
                  { h.value === sort_column && (
                    sort_order && h.value === sort_column ?
                      <Icon src={ arrow_up } alt="logo" />
                      :
                      <Icon src={ arrow_down } alt="logo" />
                  )
                  }</HeadTable>)
              )}
            </tr>
          </Header>
          <BodyTable>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ items.length }
            />
          </BodyTable>
        </CustomTable>
      </Wrapper>
    )
  }
}

SubcontractCostTable.propTypes = {
  clickRow: PropTypes.func,
}
SubcontractCostTable.defaultProps = {
  clickRow: () => {},
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const CustomTable = styled(Table)`
  background: white;
  thead {
    display: table;
    width: 100%;
    table-layout:fixed;
  } tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none;
  } thead th {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody td {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
    word-wrap: break-word;
  }
`
const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  max-height: calc(100vh - 200px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`



// WEBPACK FOOTER //
// ./src/components/subcontract-cost/table.js